<template>
    <!-- wrap -->
    <div id="wrap" class="has-step">
        <!-- header -->
        <div id="header">
            <div class="container">
                <div class="header-top">
                    <div class="back">
                        <a @click="backbtn"><i /><span class="blind">뒤로가기</span></a>
                        <span>페이스매핑 등록</span>
                    </div>

                    <div class="header-nav">
                        <a class="btn btn-home" @click="home"><i /><span class="blind">홈으로</span></a>
                    </div>
                </div>

                <div class="step-box">
                    <ul>
                        <li class="on">
                            <span>STEP1. 현장정보</span>
                        </li>
                        <li @click="nextStep(data.tunnelConstructionMethod)">
                            <span>STEP2. 막장 사진대지</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- // header -->

        <!-- content-wrap -->
        <main id="content-wrap">
            <div id="contents">
                <div class="write-form-box">
                    <div class="field-box">
                        <div class="label">
                            Construction Name
                        </div>
                        <div class="field">
                            <div class="select-box">
                                <select v-model="data.constructionName">
                                    <option
                                        v-for="(item, index) in constructionNameCodeList"
                                        :key="index"
                                        :value="item.code"
                                    >
                                        {{ item.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="field-box">
                        <div class="label">
                            Location
                        </div>
                        <div class="field">
                            <div class="select-box">
                                <select v-model="data.measureLocation">
                                    <option
                                        v-for="(item, index) in measureLocationCodeList"
                                        :key="index"
                                        :value="item.code"
                                    >
                                        {{ item.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div v-if="false" class="field">
                            <label v-for="(item, index) in measurePositionCodeList" :key="index" :value="index">
                                <input v-model="measurePositionList" :value="item.name" type="checkbox" class="chk" />
                                <span>{{ item.name }}</span>
                            </label>
                        </div>
                    </div>

                    <div class="field-box">
                        <div class="label">
                            Station(STA NO.)
                        </div>
                        <div class="field">
                            <input ref="station" v-model="data.station" type="text" class="txt half" />
                            <span class="txt">{{ stationPrefix }} {{ data.station }}</span>
                        </div>
                    </div>

                    <div class="field-box">
                        <div class="label">
                            Rock Type
                        </div>
                        <div class="field">
                            <input ref="rockType" v-model="data.rockType" type="text" class="txt half" />
                        </div>
                    </div>

                    <div class="field-box">
                        <div class="label">
                            Turnnel Construction Method
                        </div>
                        <div class="field">
                            <div class="select-box">
                                <select v-model="data.tunnelConstructionMethod">
                                    <option
                                        v-for="(item, index) in tunnelConstructionMethodCodeList"
                                        :key="index"
                                        :value="item.code"
                                    >
                                        {{ item.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="field-box">
                        <div class="label">
                            Geologist
                        </div>
                        <div class="field">
                            <input ref="geologist" v-model="data.geologist" type="text" class="txt" />
                        </div>
                    </div>

                    <div v-if="false" class="field-box">
                        <div class="label">
                            Excavation(Total)
                        </div>
                        <div class="field flex">
                            <input v-model="data.excavation" type="text" class="txt" />
                            <span>m,</span>
                            <span>(총</span>
                            <input v-model="data.excavationTotal" type="text" class="txt" />
                            <span>m)</span>
                        </div>
                    </div>

                    <div class="field-box">
                        <div class="label">
                            Date
                        </div>
                        <div class="field flex">
                            <div class="date">
                                <input v-model="data.investigationDay" type="date" class="txt date" />
                            </div>
                            <div v-if="false">
                                <div class="select-box">
                                    <select v-model="data.investigationTimeH" class="auto">
                                        <option v-for="(item, index) in timeHArray" :key="index" :value="item">
                                            {{ item }}
                                        </option>
                                    </select>
                                </div>
                                <span>시</span>
                                <div class="select-box">
                                    <select v-model="data.investigationTimeM">
                                        <option v-for="(item, index) in timeMArray" :key="index" :value="item">
                                            {{ item }}
                                        </option>
                                    </select>
                                </div>
                                <span>분</span>
                            </div>
                        </div>
                    </div>

                    <div class="field-box">
                        <div class="label">
                            file
                        </div>
                        <div class="field">
                            <input id="uploadFile" ref="uploadFile" type="file" @change="fileUpload" />
                            <label for="uploadFile" class="btn btn-upload"><span>파일 선택</span></label>
                            <button class="btn btn-delete" @click="removeFile">
                                <span>파일 삭제</span>
                            </button>
                            <span
                                class="filename"
                                style="display: inline-block;width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
                            >
                                {{ data.etcFileName }}
                            </span>
                        </div>
                    </div>

                    <div class="btn-wrapper">
                        <button type="button" class="btn btn-save" @click="save()">
                            <span>저장 및 다음단계</span>
                        </button>
                    </div>
                </div>
            </div>
        </main>
        <!-- // content-wrap -->
    </div>
    <!-- // wrap -->
</template>

<script>
import { mapActions, mapState } from 'vuex';
import CodeApi from '../api/CodeApi';
import FacemappingApi from '../api/FacemappingApi';
import FileApi from '../api/FileApi';
import { CONSTRUCTION, CONSTRUCTION_NM, TYPE } from '../const';

export default {
    name: 'Step1',
    components: {},
    data: () => {
        return {
            id: null,
            data: {
                investigationTimeH: '00',
                investigationTimeM: '00',
                measureLocation: '010001',
                rockType: '',
                etcFile: '',
                etcFileName: '',
                tunnelConstructionMethod: '017001'
            },
            measureLocationCodeList: {},
            rockTypeCodeList: {},
            measurePositionCodeList: {},
            tunnelConstructionMethodCodeList: {},
            constructionNameCodeList: [],
            measurePositionList: [],
            timeHArray: [],
            timeMArray: [],
            stationPrefix: 'STA NO.'
        };
    },
    computed: {
        ...mapState({})
    },
    beforeCreate() {
        ///////////////////////
        // Initializer Area
        ///////////////////////
        //this.showLoading();
        //this.$store.dispatch('showLoading');
        this.hideLoading();
    },
    created() {
        this.id = this.$route.params.id;
    },
    mounted() {
        this.codeSettign('010');
        this.codeSettign('013');
        this.codeSettign('015');
        this.codeSettign('017');

        for (var i = 0; i < 60; i++) {
            var _target = i;
            _target = _target < 10 ? '0' + _target : _target;
            if (_target < 24) this.timeHArray.push(_target);
            this.timeMArray.push(_target);
        }

        if (localStorage.getItem(TYPE) === 'admin') {
            this.codeSettign('016');
        } else {
            this.constructionNameCodeList.push({
                name: localStorage.getItem(CONSTRUCTION_NM),
                code: localStorage.getItem(CONSTRUCTION)
            });
            this.data.constructionName = localStorage.getItem(CONSTRUCTION);
        }

        if (this.id) {
            this.dataObj();
        } else {
            this.data.geologist = localStorage.getItem('name');
        }
    },
    beforeDestroy() {},
    methods: {
        ...mapActions(['showLoading', 'hideLoading']),
        backbtn() {
            this.$router.push({
                name: 'List'
            });
        },
        home() {
            this.$router.push({
                name: 'Main'
            });
        },
        nextStep(tunnelConstructionMethod) {
            if (this.id !== null) {
                if (tunnelConstructionMethod === '017001') this.$router.push({ path: `/step2/${this.id}` });
                else this.$router.push({ path: `/step2TBM/${this.id}` });
            }
        },
        dataObj() {
            this.showLoading();
            FacemappingApi.detail(this.id).then(res => {
                this.data = res.content;
                this.measurePositionList = res.content.measurePosition.split(',');
                //this.data.constructionName = this.data.constructionName;
                //this.data.constructionNameValue = this.data.constructionNameValue;
                var investigationTimeArray = this.data.investigationTime.split(':');
                this.data.investigationTimeH = investigationTimeArray[0];
                this.data.investigationTimeM = investigationTimeArray[1];
                this.hideLoading();
            });
        },
        codeSettign(code) {
            CodeApi.subCodeList(code, 2).then(res => {
                if (code === '010') this.measureLocationCodeList = res.content;
                if (code === '013') this.rockTypeCodeList = res.content;
                if (code === '015') this.measurePositionCodeList = res.content;
                if (code === '017') this.tunnelConstructionMethodCodeList = res.content;
                if (code === '016') {
                    this.constructionNameCodeList = res.content;
                    this.data.constructionName = res.content[0].code;
                }
            });
        },
        save() {
            if (!this.data.station) {
                alert('Station을 입력하세요');
                this.$refs.station.focus();
                return;
            }

            const regexStation = /^\d+\+\d{1,3}(\.\d+)?$/;
            if (!regexStation.test(this.data.station)) {
                alert("Station 형식이 잘못되었습니다. '0+000' 형식으로 입력하세요");
                this.$refs.station.focus();
                return;
            }

            if (!this.data.rockType) {
                alert('Rock타입을 입력하세요');
                this.$refs.rockType.focus();
                return;
            }

            if (!this.data.geologist) {
                alert('Geologist를 입력하세요');
                this.$refs.geologist.focus();
                return;
            }
            if (!this.data.investigationDay) {
                alert('Date를 입력하세요');
                this.$refs.geologist.focus();
                return;
            }

            /// this.data.investigationTime = this.data.investigationTimeH + ':' + this.data.investigationTimeM;
            this.data.investigationTime = '00:00';
            this.data.investigationDay = this.data.investigationDay.replace(/-/gi, '');
            if (this.data.investigationTimeH && this.data.investigationTimeM)
                this.data.judgementTime = this.data.investigationTimeH + ':' + this.data.investigationTimeM;
            else this.data.judgementTime = '00:00';

            if (this.data.judgementDay) this.data.judgementDay = this.data.judgementDay.replace(/-/gi, '');

            var measurePosition = '';
            $.each(this.measurePositionList, function(idx) {
                if (idx !== 0) {
                    measurePosition += ',' + this;
                } else {
                    measurePosition += this;
                }
            });
            this.data.measurePosition = measurePosition;
            this.data.meter = this.parseStationNumber(this.data.station);

            this.showLoading();
            FacemappingApi.saveSiteInfo(this.data).then(res => {
                this.$router.push({ path: `/step2/${res.content}` });
                this.hideLoading();
            });
        },
        async fileUpload() {
            const fileObject = this.$refs.uploadFile.files[0];
            const formData = new FormData();

            formData.append('file_id', '');
            formData.append('file_no', 1);
            formData.append('file', fileObject);
            this.showLoading();
            const fileRes = await FileApi.fileUpload(formData, 'doc');
            this.data.etcFile = fileRes.content[0].id.fileId;
            this.data.etcFileName = fileRes.content[0].name;
            this.hideLoading();
        },
        removeFile() {
            this.data.etcFile = '';
            this.data.etcFileName = '';
        },
        parseStationNumber(staString) {
            // 정규 표현식으로 "STA NO." 부분을 무시하고 km와 미터 값을 추출합니다.
            // `\+`를 포함하거나 포함하지 않는 경우 모두 고려합니다.
            const regex = /(\d+)\+?(\d*\.?\d*)/i;

            const match = staString.match(regex);

            if (match) {
                // km 부분이 비어 있으면 0으로 간주합니다.
                let km = 0;
                let meters = 0;

                if (match[2]) {
                    // "+" 기호를 포함하고 뒤에 숫자가 있다면
                    km = parseInt(match[1], 10);
                    meters = parseFloat(match[2]);
                } else {
                    // "+" 기호 없이 숫자만 있다면
                    meters = parseFloat(match[1]);
                }

                console.log(`sta: ${staString}, km: ${km}, meters: ${meters}`);
                // 전체 미터 계산: km * 1000 + meters
                const totalMeters = km * 1000 + meters;
                return totalMeters;
            }
            return 0;
        }
    }
};
/*
#wrap > div {
    height: inherit;
}
*/
</script>
